module.exports = __webpack_public_path__ + "media/images/1000px_Top_Logo_Banner_wBalls-fc093c213c1d8d8c870d4b1680850de4.png";